import { useRef } from "react";
import { SearchBarFrame } from "./SearchBarFrame";

export function SearchBar({
  label = "Search...",
  onSearch,
}: {
  label?: string;
  onSearch?: (str: string) => void;
}) {
  const inputRef = useRef<HTMLInputElement>(null);

  const handleSearch = () => {
    if (inputRef.current && onSearch) {
      onSearch(inputRef.current.value);
    }
  };

  return (
    <SearchBarFrame
      onClick={handleSearch}
      className="tw:focus-within:!border-cn-btn-primary"
    >
      <input
        ref={inputRef}
        placeholder={label}
        className="tw:focus:!outline-none tw:!text-gray-600"
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            handleSearch();
          }
        }}
      />
    </SearchBarFrame>
  );
}
